var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { useFormContext } from 'react-hook-form';
import { Form } from '@tribeplatform/react-components/Form';
import { Button as DumbButton } from '@tribeplatform/react-ui-kit/Button';
import { Link } from '@tribeplatform/react-ui-kit/Link';
import { useSlate } from '../../hooks/index.js';
import { getIcon } from './utils.js';
export const ButtonBlock = props => {
    const { callbackId, leadingIcon, trailingIcon, autoDisabled = true, autoLoading = true, text, link, children: givenChildren } = props, rest = __rest(props, ["callbackId", "leadingIcon", "trailingIcon", "autoDisabled", "autoLoading", "text", "link", "children"]);
    const { extraContext: { slate: { callback }, }, } = useSlate();
    const formContext = useFormContext();
    const { control: enabled, formState: { isSubmitting, isDirty, isValid }, } = formContext || {
        formState: {},
    };
    const isLoading = isSubmitting;
    const isDisabled = !isDirty || !isValid;
    const childrenItems = React.Children.toArray(givenChildren);
    const children = childrenItems.length ? childrenItems : text;
    const [loading, setLoading] = useState(isLoading);
    useEffect(() => {
        if (isLoading !== undefined) {
            setLoading(isLoading);
        }
    }, [isLoading]);
    if (link) {
        return (React.createElement(DumbButton, Object.assign({ as: Link, href: link }, rest, { leadingIcon: leadingIcon ? getIcon(leadingIcon) : null, className: clsx(text && 'justify-center') }), children));
    }
    if (enabled) {
        return (React.createElement(Form.Actions, null,
            React.createElement(DumbButton, Object.assign({}, rest, { loading: autoLoading ? rest.type === 'submit' && loading : rest.loading, disabled: autoDisabled ? loading || isDisabled : rest.disabled, leadingIcon: leadingIcon ? getIcon(leadingIcon) : null, className: clsx(text && 'justify-center') }), children)));
    }
    return (React.createElement(DumbButton, Object.assign({ onClick: async (event) => {
            if (rest === null || rest === void 0 ? void 0 : rest.onClick) {
                rest.onClick(event);
            }
            else if (callbackId && callback) {
                setLoading(true);
                try {
                    await callback(callbackId);
                }
                catch (_a) { }
                setLoading(false);
            }
        } }, rest, { loading: autoLoading ? loading : rest.loading, leadingIcon: leadingIcon ? getIcon(leadingIcon) : null, trailingIcon: trailingIcon ? getIcon(trailingIcon) : null, className: clsx(text && 'justify-center') }), children));
};
//# sourceMappingURL=Block.js.map